<template>
<base-auth>
    <div v-if="false" class="kt-login__form">
        <div class="alert alert-danger" v-if="message">
            {{message}}
        </div>
        <form class="kt-form" @submit.prevent="onSubmit">
            <vue-recaptcha
                v-if="captchaDriver === 'recaptcha'"
                ref="invisibleRecaptcha"
                @verify="onVerify"
                @expired="onExpired"
                size="invisible"
                :sitekey="sitekey"
                :loadRecaptchaScript="true">
            </vue-recaptcha>
            
            <arcaptcha-vue
                v-if="captchaDriver === 'arcaptcha'"
                ref="arcaptcha"
                :site_key="arCaptchaKey"
                :invisible="true"
                :callback="onArcaptchaSuccess"
                :expired_callback="onArcaptchaExpired"
                :error_callback="onArcaptchaError"
            />
            
            <div class="mb-4 pb-4">
                <kt-form-label v-if="user_type == ''" for="user_type">
                    {{ $t('user_types.label.please_select_user_type') }}
                </kt-form-label>
                <select
                    id="user_type"
                    name="user_type"
                    v-model="user_type"
                    class="form-control kt-selectpicker"
                >
                    <option v-for="(user_type, index) in user_types" :key="index" :value="user_type">{{ user_types_str.get(user_type) }}</option>
                </select>
            </div>
            <span v-if="user_type != ''">
                <span v-if="user_type == user_types.REAL">
                    <kt-form-group>
                        <kt-form-control
                            v-bind:placeholder="$t('auth.placeholder.first_name')"
                            name="first_name"
                            v-model="first_name"
                            />
                    </kt-form-group>
                    <kt-form-group>
                        <kt-form-control
                        v-bind:placeholder="$t('auth.placeholder.last_name')"
                        name="last_name"
                        v-model="last_name"
                        />
                    </kt-form-group>
                </span>
                <span v-else-if="user_type == user_types.LEGAL">
                    <kt-form-group>
                        <kt-form-control
                            :placeholder="$t('label.com_name_fa')"
                            name="com_name_fa"
                            v-model="com_name_fa"
                        />
                    </kt-form-group>
                </span>
                <kt-form-group>
                    <kt-form-control
                    v-bind:placeholder="$t('auth.placeholder.phone')"
                    name="phone"
                    v-model="phone"
                    id="phone"
                    />
                </kt-form-group>
                <kt-form-group>
                    <kt-form-control
                    is_last
                    v-bind:placeholder="$t('auth.placeholder.password')"
                    name="password"
                    type="password"
                    autocomplete="off"
                    v-model="password"
                    />
                </kt-form-group>
                <div class="kt-login__extra">
                    <kt-form-check name="agree" v-model="agree">
                        {{ $t('auth.agree') }} <kt-link variant="brand">
                            {{ $t('auth.terms_and_condition') }}
                        </kt-link>
                    </kt-form-check>
                </div>
            </span>
            <div class="kt-login__actions">
                <kt-button type="submit" id="login_signup_submit" variant="brand" class="btn-pill btn-elevate">
                    {{ $t('auth.btn.sign_up') }}
                </kt-button>
            </div>
        </form>
    </div>
    <div class="kt-login__account">
        <span class="kt-login__account-msg">
            {{ $t('auth.already_signed') }}
        </span>&nbsp;&nbsp;
        <router-link to="/login" class="kt-login__account-link">{{ $t('auth.btn.sign_in') }}</router-link>
    </div>
</base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth'
import { KTApp } from '@/plugins/core/app'
import $ from 'jquery'
import { mapGetters, mapActions } from 'vuex'
import {blackList} from "../constants/securityStatus";
import { i18n } from '@/plugins/i18n';
import { userTypes, userTypesStr } from '@/constants/userTypes';
import VueRecaptcha from 'vue-recaptcha'
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import ArcaptchaVue from 'arcaptcha-vue'

export default {
    data() {
        return {
            user_types: userTypes,
            user_types_str: userTypesStr,
            com_name_fa: '',
            user_type: '',
            first_name: '',
            last_name: '',
            phone: '',
            password: '',
            agree: false,
            referer_id: this.$route.params.referer_id,
            login_event: null,
            recaptcha_verified: false,
            g_recaptcha_response: '',
            sitekey: reCaptchaKeys,
            arCaptchaKey: arCaptchaKeys,
            captchaDriver: getCaptchaDriver,
            arcaptchaToken: '',
            arcaptchaVerified: false,
            message: ""
        }
    },
    computed: {
        ...mapActions('auth',['sendVerifyStatus']),
    },
    components: {
        'base-auth': baseAuth,
        'vue-recaptcha': VueRecaptcha,
        ArcaptchaVue,
    },
    mounted() {
        setTimeout(() => {
            $('.kt-selectpicker').selectpicker({
                size: 2,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        }, 1000);
    },
    methods: {
        onSubmit: function (e) {
            this.message = "";
            this.login_event = e;
            this.executeCaptcha();
        },
        
        executeCaptcha() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptcha.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
                this.$refs.arcaptcha.execute();
            } else {
                this.register(this.login_event);
            }
        },
        
        onVerify(response) {
            this.recaptcha_verified = true;
            this.g_recaptcha_response = response;
            this.register(this.login_event);
        },
        
        onExpired() {
            this.recaptcha_verified = false;
        },
        
        resetRecaptcha() {
            this.$refs.invisibleRecaptcha && this.$refs.invisibleRecaptcha.reset();
        },
        
        onArcaptchaSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.register(this.login_event);
        },
        
        onArcaptchaExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
        },
        
        onArcaptchaError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.showMsg($('.kt-form'), 'danger', 'Captcha verification failed. Please try again.');
        },
        
        resetArcaptcha() {
            this.$refs.arcaptcha && this.$refs.arcaptcha.reset();
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
        },
        
        isCaptchaVerified() {
            if (this.captchaDriver === 'recaptcha') {
                return this.recaptcha_verified;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaVerified && this.arcaptchaToken;
            }
            return true;
        },
        
        getCaptchaResponse() {
            if (this.captchaDriver === 'recaptcha') {
                return this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaToken;
            }
            return '';
        },
        
        register(e) {
            let form = $(e.target)
            let btn = $('#login_signup_submit')

            form.validate({
                ignore: ".ignore",
                rules: {
                    user_type: {
                        required: true,
                    },
                    com_name_fa: {
                        required: () => {
                            return this.user_type == this.user_types.LEGAL;
                        },
                    },
                    first_name: {
                        required: () => {
                            return this.user_type == this.user_types.REAL;
                        },
                    },
                    last_name: {
                        required: () => {
                            return this.user_type == this.user_types.REAL;
                        },
                    },
                    password: {
                        required: true,
                    },
                    phone: {
                        required: true,
                    },
                    agree: {
                        required: true,
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            if (!this.isCaptchaVerified()) {
                return;
            }

            let referer = null
            if(this.getCookie('referer_id')){
                referer = this.getCookie('referer_id')
            }

            let params = {
                user_type: this.user_type,
                com_name_fa: this.com_name_fa,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: this.phone,
                password: this.password,
                agree: this.agree,
                referer_id: referer
            }

            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            KTApp.progress(btn)

            this.$store.dispatch('auth/register', params)
            .then((response) => {
                if(response.status === blackList.FORBIDDEN) {
                    this.showMsg(form, 'danger', response.message)
                    return;
                }
                this.$store.dispatch('auth/setRegisterData', params)
                this.$router.push('/verifyRegister')
            })
            .catch((response) => {
                form.validate().showErrors(response.data.data)
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
                if (this.captchaDriver === 'recaptcha') {
                    this.resetRecaptcha();
                } else if (this.captchaDriver === 'arcaptcha') {
                    this.resetArcaptcha();
                }
            })
        },
        
        getCookie(name) {
            let cookieName = name + "="
            let decodedCookie = decodeURIComponent(document.cookie)
            let cookieArray = decodedCookie.split(';')
            for(let i = 0; i <cookieArray.length; i++) {
                while (cookieArray[i].charAt(0) === ' ') {
                    cookieArray[i] = cookieArray[i].substring(1);
                }
                if (cookieArray[i].indexOf(cookieName) === 0) {
                    return cookieArray[i].substring(cookieName.length, cookieArray[i].length);
                }
            }
            return "";
        },
        sendVerify(e) {
            let btn = $(e.target)
            let form = $('.kt-form')
            let phone = $('#phone')

            let params = {
                phone: phone.val(),
            }

            KTApp.progress(btn)
            this.$store.dispatch('auth/sendVerifyRegister', params)
                .then(response => {
                    this.showMsg($('.kt-form'), 'success', response.message)
                    this.sent = true
                    this.sendVerifyStatus
                })
                .catch(response => {
                    this.showMsg($('.kt-form'), 'danger', response.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        
        showMsg(form, type, message) {
            this.message = message;
        }
    }
}
</script>

<style>

</style>